import React from "react";
import { withStyles, createStyles, WithStyles, Theme } from "@material-ui/core/styles";

import IconDelete from "@material-ui/icons/Delete";
import IconEdit from "@material-ui/icons/Edit";
import { CellActionsFormatter } from "../../lib/helpers/CellActionsFormatter";
import { DateFormatter } from "../../lib/components/Formatters";
import CustomAutoCompleteFilter from "../../lib/components/customdatagridfilter/CustomFilter";

const cellWidthXSmall = 80;
const cellWidthSmall = 115;
const cellWidthMedium = 150;
const cellWidthLarge = 220;

const defaultColumnProperties = {
  resizable: true,
  sortable: true,
};

export const GridColumns = (maintenancemode, handleRemove, handleEdit, data, filters, columnArrangement, columnsWidth) => {
  const columnsArr = [];

  if (maintenancemode) {
    columnsArr.push({
      key: "actions",
      name: "Actions",
      width: cellWidthXSmall,
      formatter: ({ row }) => {
        const actions = cellActions(row, handleRemove, handleEdit);
        return (
          <div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
            <CellActionsFormatter actions={actions} />
          </div>
        );
      },
    });
  }

  columnsArr.push(
    {
      key: "templatename",
      name: "Template",
      width: cellWidthLarge,
      filterable: true,
      filterRenderer: (props) => (
        <CustomAutoCompleteFilter
          {...props}
          multiSelection={true}
          currentFilters={filters}
          fieldname={"templatename"}
          data={data}
          section="templatesMaster"
        />
      ),
    },
    {
      key: "created_at",
      name: "Created Date",
      width: cellWidthSmall,
      formatter: DateFormatter,
      filterable: true,
      filterRenderer: (props) => (
        <CustomAutoCompleteFilter
          {...props}
          multiSelection={true}
          currentFilters={filters}
          fieldname={"created_at"}
          data={data}
          section="templatesMaster"
        />
      ),
    },
    {
      key: "variety_name",
      name: "Variety",
      width: cellWidthMedium,
      filterable: true,
      filterRenderer: (props) => (
        <CustomAutoCompleteFilter
          {...props}
          multiSelection={true}
          currentFilters={filters}
          fieldname={"variety_name"}
          data={data}
          section="templatesMaster"
        />
      ),
    },
    {
      key: "commodity_code",
      name: "Commodity",
      width: cellWidthXSmall,
      filterable: true,
      filterRenderer: (props) => (
        <CustomAutoCompleteFilter
          {...props}
          multiSelection={true}
          currentFilters={filters}
          fieldname={"commodity_code"}
          data={data}
          section="templatesMaster"
        />
      ),
    }
  );

  let arrangedColumns = columnsArr;
  if (columnArrangement && columnArrangement.length > 0) {
    arrangedColumns = [];

    for (const colName of columnArrangement) {
      const foundColumn = columnsArr.find(col =>
        col.name === colName || col.key === colName
      );
      if (foundColumn) {
        arrangedColumns.push(foundColumn);
      }
    }

    for (const column of columnsArr) {
      if (!arrangedColumns.find(col => col.key === column.key)) {
        arrangedColumns.push(column);
      }
    }
  }

  if (columnsWidth && columnsWidth.length > 0) {
    arrangedColumns = arrangedColumns.map(column => {
      const widthConfig = columnsWidth.find(w => w.name === column.name);
      return widthConfig ? { ...column, width: widthConfig.width } : column;
    });
  }

  return arrangedColumns.map((c) => ({ ...c, ...defaultColumnProperties }));
};

const cellActions = (template, handleRemove, handleEdit) => {
  let actions = [
    {
      icon: (
        <span title="Delete Template">
          <IconDelete style={{ cursor: "pointer", color: "red" }} />
        </span>
      ),
      callback: (e) => {
        handleRemove(template.id);
      },
    },
    {
      icon: (
        <span title="Edit Template">
          <IconEdit style={{ cursor: "pointer", color: "orange" }} />
        </span>
      ),
      callback: (e) => {
        handleEdit(template);
      },
    },
  ];
  return actions;
};
